import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {SSOProvider} from "../../_types/auth";

@Component({
    selector: 'app-sso-modal',
    standalone: false,
    templateUrl: './sso-modal.component.html',
    styleUrl: './sso-modal.component.scss',
})
export class SsoModalComponent {

    constructor(
        private readonly matDialog: MatDialogRef<SsoModalComponent>,
        @Inject(MAT_DIALOG_DATA) protected data: { providers: SSOProvider[], community: number },
    ) {
    }
}
